import { format, addDays, parseISO } from 'date-fns';

import { token } from '@atlaskit/tokens';

const MIN_VARIANCE = 0.1;

export type ColorAccessorParams = {
  value: number | undefined;
  average: number;
  averageComparator?: (value: number, average: number) => boolean;
  standardDeviation: number;
};

export const inclineValueComparator = (x: number, y: number): boolean => x >= y;
export const declineValueComparator = (x: number, y: number): boolean => x <= y;

export const valueIsOutlier = (
  value: number,
  average: number,
  standardDeviation: number
): boolean => {
  return (
    standardDeviation >= average * MIN_VARIANCE &&
    Math.abs(value - average) > standardDeviation
  );
};

export const averageColorAccessor = ({
  value,
  average,
  averageComparator = (v, a) => v <= a,
  standardDeviation,
}: ColorAccessorParams): string => {
  if (!value) return '';

  const valueIsBetterThanAverage = averageComparator(value, average);

  if (!valueIsOutlier(value, average, standardDeviation))
    return token('color.chart.neutral', '#8590A2');

  if (valueIsBetterThanAverage) {
    return token('color.chart.success', '#22A06B');
  } else {
    return token('color.chart.danger', '#F15B50');
  }
};

export const generateTimeRange = (startAt: string): string => {
  const startDate = parseISO(startAt);
  const localStartAt = format(startDate, 'dd MMM');
  const endDate = addDays(startDate, 7);
  const localEndAt = format(endDate, 'dd MMM');
  return `${localStartAt} - ${localEndAt}`;
};
